<template>
    <div>
        <h3 class="h6 block-title border-bottom ps-0 mb-3">
            Avoir
        </h3>

        <div class="block-content block-content-full bg-body-light rounded mb-3">

            <div v-for="(item, i) in creditsUsed" :key="'credit-'+i">
                <input type="hidden" name="credits-used[]" :value="JSON.stringify(item)" />
            </div>

            <div class="d-flex flex-column w-100">

                <label class="form-label">Numéro d'avoir :</label>
                <input type="text" ref="creditCode" class="form-control mb-3" />

                <div v-if="invalidCredit && error" class="text-danger mb-3">
                    {{ error }}
                </div>

                <div v-for="(item, i) in creditsUsed" :key="i" class="d-flex justify-content-between">
                    <p class="text-success mb-2">
                        - Avoir n°{{ item.serial_number }} :
                        {{ item.amount }}€
                        (émis le {{ parseDate(item.issued_at) }})
                    </p>
                    <button type="button" @click="deleteCredit(item)">
                        <i class="fa fa-times"></i>
                    </button>
                </div>

                <button
                    type="button"
                    class="btn btn-primary rounded-pill px-3 mt-2"
                    @click="handleCreditSearch"
                >
                    Appliquer
                </button>
            </div>
        </div>

        <div v-if="creditsUsed.length > 0" class="block shadow-sm rounded">
            <div class="block-header">
                <h6 class="block-title">Montant à utiliser</h6>
            </div>

            <div class="block-content">
                <ul v-for="(item, i) in creditsUsed" :key="i">
                    <li class="row">
                        <span class="col-4">
                            - Avoir n°<b>{{ item.serial_number }}</b> :
                        </span>

                        <div class="col-8">
                            <div class="input-group">
                                <input
                                    type="number"
                                    class="form-control"
                                    min="0"
                                    placeholder="0"
                                    :max="creditMaxAmount(item)"
                                    v-model="item.used_amount"
                                    @input="clampCreditAmount(item)"
                                    @blur="clampCreditAmount(item)"
                                />
                                <span class="input-group-text bg-primary text-light">€</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>


<script>
import ApiManager from '../../Calendar/_core/ApiManager'
import { get, sync } from 'vuex-pathify'

export default {

    data: () => ({
        creditArray: [],
        creditsUsed: [],
        invalidCredit: false,
        error: null,
    }),

    computed: {
        ...sync('overlay@data', {
            c_creditUsed: 'creditUsed',
            c_payments: 'payments',
        }),
        ...get('overlay@data', {
            c_remainPrice: 'remainPrice',
            c_remainAfterGlobalPromoCode: 'remainAfterGlobalPromoCode',
        }),
    },

    watch: {

        creditArray(newVal) {
            newVal.forEach(el => {
            if (!this.creditsUsed.find(c => c.id == el.id)) {
                this.creditsUsed.push({
                id: el.id,
                serial_number: el.serial_number,
                amount: el.amount,
                remaining_amount: el.remaining_amount,
                issued_at: el.issued_at,
                used_amount: this.clampAmount(
                    Math.min(this.toAmount(this.c_remainPrice), this.toAmount(el.remaining_amount)),
                    this.toAmount(el.remaining_amount)
                )
                })
            }
            })
        },

        creditsUsed: {
            handler(newVal) {

            newVal.forEach(item => this.clampCreditAmount(item))

            this.c_creditUsed = this.creditsUsed

            this.$emit(
                'credits-update',
                newVal.map(x => this.toAmount(x.used_amount))
            )
            },
            deep: true,
        },
    },

    methods: {
        toAmount(value) {
            const amount = parseFloat(String(value ?? 0).replace(',', '.'))

            return Number.isFinite(amount) ? amount : 0
        },
        creditMaxAmount(item) {
            const currentCreditCapacity = Math.max(
                0,
                this.toAmount(this.c_remainPrice) + this.toAmount(item.used_amount)
            )
            const capacityAfterOtherPayments = Math.max(
                0,
                this.toAmount(this.c_remainAfterGlobalPromoCode)
                    - this.nonCreditPaymentsAmount()
                    - this.otherCreditsAmount(item)
            )
            const paymentCapacity = Math.min(
                currentCreditCapacity || capacityAfterOtherPayments,
                capacityAfterOtherPayments
            )

            return Math.max(
                0,
                Math.min(
                    paymentCapacity,
                    this.toAmount(item.remaining_amount)
                )
            )
        },
        nonCreditPaymentsAmount() {
            if (!this.c_payments) {
                return 0
            }

            return this.c_payments
                .filter(payment => payment.name !== 'Rbt Avoir')
                .reduce((total, payment) => total + this.toAmount(payment.value), 0)
        },
        otherCreditsAmount(currentItem) {
            return this.creditsUsed
                .filter(item => item.id !== currentItem.id)
                .reduce((total, item) => total + this.toAmount(item.used_amount), 0)
        },
        clampAmount(value, max) {
            const amount = this.toAmount(value)
            const capped = Math.min(Math.max(amount, 0), Math.max(0, this.toAmount(max)))

            return Math.round(capped * 100) / 100
        },
        clampCreditAmount(item) {
            if (item.used_amount === '' || item.used_amount === null || item.used_amount === undefined) {
                return
            }

            const capped = this.clampAmount(item.used_amount, this.creditMaxAmount(item))

            if (this.toAmount(item.used_amount) !== capped) {
                item.used_amount = capped
            }
        },

        handleCreditSearch() {

            if (!this.$refs.creditCode.value) return
            console.log('ref', this.$refs.creditCode.value)
            axios.get('/back-office/avoirs/check-number', {
                params: { serial_number: this.$refs.creditCode.value }
            })
            .then(res => {

                if (!res.data || typeof res.data === 'string') {
                    this.invalidCredit = true
                    this.error = res.data || "Avoir introuvable"
                    return
                }

                if (!this.creditArray.find(c => c.id == res.data.id)) {
                    this.creditArray.push(res.data)
                }

                this.invalidCredit = false
                this.$refs.creditCode.value = ''
            })
            .catch(err => {
                this.invalidCredit = true
                this.error = err.response?.data?.message || "Erreur serveur"
            })
        },

        deleteCredit(credit) {
            this.creditArray = this.creditArray.filter(c => c.id !== credit.id)
            this.creditsUsed = this.creditsUsed.filter(c => c.id !== credit.id)
        },

        parseDate(date) {
            return moment(date).format('DD/MM/YYYY')
        }
    }
}

</script>

<style></style>
